// extracted by mini-css-extract-plugin
module.exports = {"table":"_d1a9ebc","tableBody":"_4c961d3","tableBodyAllOtherScore":"_3ac3f48","allOtherScoreRow":"_3781150","allOtherScoreRunner":"_473c99f"};